(function () {
  'use strict';

  var bootstrapScript = document.currentScript;
  var configurator = bootstrapScript && bootstrapScript.closest('[data-wedding-ring-configurator]');

  if (!configurator) {
    return;
  }

  var language = (configurator.dataset.configuratorLanguage || 'fr').split('-')[0].toLowerCase();

  try {
    localStorage.setItem('language', language);
  } catch (error) {
    // BM Rings can still receive the language through setLanguage when storage is unavailable.
  }

  var applyLanguage = function () {
    if (typeof window.setLanguage === 'function') {
      window.setLanguage(language);
    }
  };

  document.addEventListener('metrix:configuratorInitialized', applyLanguage, { once: true });
  applyLanguage();
})();
